import i18n from '../../../i18n';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import AppBreadcrumb from '../../Shared/AppBreadcrumb';
import FecthingSpinner from '../../Shared/FecthingSpinner';
import httpService from "../../../services/http.service";
import * as logger from "../../../services/logger.service";
import moment from 'moment';
import { getUserFullName } from '../../../utils';
import MyOpinionLogo from "../../../assets/images/MyOpinion_Logo_Head.png";
import { Link } from "react-router-dom";

const PaymentList = ({ history, location, match, ...props }) => {
    const { t } = useTranslation();
  const [payments, setPayments] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 20,
    total: 0,
  });

  const fetchData = async (page = 1) => {
    try {
      setFetching(true);
      const response = await httpService.get(`/payments?page=${page}`);
      const { data, ...meta } = response.data;
      console.log("Liste des paiements chargée", data.data);
      setPayments(data.data);
      setPagination(meta);
    } catch (error) {
      logger.error('Erreur chargement paiements', error);
    } finally {
      setFetching(false);
    }
  };

  const goToPage = (page) => {
    if (page >= 1 && page <= pagination.last_page) {
      fetchData(page);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="container-fluid">
      <AppBreadcrumb title={t("Liste des transactions")} />
      {fetching ? (
        <FecthingSpinner />
      ) : (
        // <div className="col-md-12">
        <div className="card">
          {/* <div className="font-weight-normal">
              <h5>{t("Liste des paiements")}</h5>
            </div> */}
          <div className="table-responsive">
            <table className="table table-hover table-custom spacing8">
              <thead>
                <tr>
                  <th>{t("Profile")}</th>
                  <th>{t("Utilisateur")}</th>
                  <th>{t("Référence")}</th>
                  <th>{t("Bénéficiaire")}</th>
                  <th>{t("Compte")}</th>
                  <th>{t("Montant")}</th>
                  <th>{t("Type")}</th>
                  <th>{t("Status")}</th>
                  <th>{t("Date")}</th>
                </tr>
              </thead>
              <tbody>
                {payments?.map((payment) => (
                  <tr key={payment.payment_id}>
                    <td className="w60">
                      <img
                        src={payment?.user?.profile?.prof_picture || MyOpinionLogo}
                        data-toggle="tooltip"
                        data-placement="top" alt={`image`}
                        className="w35 rounded"
                        style={{ objectFit: 'cover' }}
                      />
                    </td>
                    <td>
                      <Link
                        to={`payments/${payment.payment_transfer_reference_no}`}
                        className='text-secondary'>
                        {getUserFullName(payment?.user, true)}{' '}
                        {payment?.user?.user_verified ? (
                          <i style={{ cursor: 'pointer' }} title={t("Verified")} className="fa fa-check-circle-o text-primary mr-1" />
                        ) : null}
                        {payment?.user.user_gold ? (
                          <i style={{ cursor: 'pointer' }} title={t("Premium / Gold")} className="fa fa-star text-warning mr-1" />
                        ) : null}
                      </Link>
                    </td>
                    <td>{payment.payment_transaction_id}</td>
                    <td>{payment.payment_beneficiary_name}</td>
                    <td style={{ fontWeight: '500' }}>
                      <Link
                        to={`payments/${payment.payment_transfer_reference_no}`}
                        className='text-secondary'>
                        {payment?.payment_account_number
                          ? `${payment.payment_credit_account_branch} - ${payment.payment_account_number}`
                          : payment.payment_beneficiary_account_no
                            ? `${payment.payment_destination_bank_code} - ${payment.payment_beneficiary_account_no}`
                            : payment.payment_stripe_account_id ? payment.payment_stripe_account_id : payment?.payment_transfer_type === 'mobile_money' ? payment.payment_beneficiary_phone
                              : '-'
                        }
                      </Link>
                    </td>
                    <td>{payment.payment_amount} {payment.payment_currency}</td>
                    <td>
                      {payment.payment_type === 'ALL'
                        ? i18n.t("Coins, likes et vues")
                        : payment.payment_type === 'COIN'
                          ? 'Coins'
                          : payment.payment_type === 'LIKE'
                            ? 'Likes'
                            : 'Vues'
                      }
                    </td>
                    <td>
                      <span className={`badge ${payment.payment_status === 'success'
                        ? 'badge-success'
                        : payment.payment_status === 'pending'
                          ? 'badge-outline-secondary'
                          : 'badge-danger'
                        }`}>
                        {payment.payment_status}
                      </span>
                    </td>
                    <td>{moment(payment.payment_execution_date).format('DD/MM/YYYY HH:mm')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="pagination mt-3 d-flex justify-content-center">
            <button
              className="btn btn-outline-secondary mx-1"
              onClick={() => goToPage(pagination.current_page - 1)}
              disabled={pagination.current_page === 1}
            >
              Précédent
            </button>

            {[...Array(pagination.last_page)].map((_, i) => (
              <button
                key={i}
                className={`btn mx-1 ${pagination.current_page === i + 1 ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => goToPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="btn btn-outline-secondary mx-1"
              onClick={() => goToPage(pagination.current_page + 1)}
              disabled={pagination.current_page === pagination.last_page}
            >
              Suivant
            </button>
          </div>
        </div>
        // </div>
      )}
    </div>
  );
};

export default PaymentList;
